import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';

import ImageScroller from '../../components/imagescroller';
import ClipboardCopy from '../../components/gui/clipboardCopy';
import GoogleSheet from '../../components/google/sheet';
import Placeholder from '../../components/gui/placeholder';
import PlaceholderTable from '../../components/gui/placeholderTable';

import VideoStreamingPlayer from '../../routes/videostreaming/player';
import ConventionResultAiAnalysisPanel from './aiAnalysisPanel';

import localUtil from '../../lib/util';

function displayImage(img, props, size = '150x') {
    if (typeof img !== 'object') {
        return undefined;
    }
    const imgSrc = `${img.s3LargeLink}`;
    return imgSrc;
}

@observer
class ConventionResultView extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sessionid: new Date().getTime(),
        };
        this.mainContainer = null;
    }

    loadAll = async (props = this.props) => {
        const { id, uuidv4, all } = props;
        const { conventionResultStore, appState } = this.props.stores;
        if (id) {
            conventionResultStore.updateKeyValue('conventionResult', {});
            conventionResultStore.updateKeyValue('googleSheet', {});

            const query = { hostname: conventionResultStore.currentHostname };
            if (all) {
                query.all = 1;
            }
            await conventionResultStore.load(id, false, { addData: ['tags'], query });
            const { conventionResult } = conventionResultStore;
            if (conventionResult.googleSheetId) {
                conventionResultStore.getGoogleSheet(conventionResult.googleSheetId);
            }
        }
        if (uuidv4) {
            conventionResultStore.updateKeyValue('conventionResult', {});
            const conventionResults = await conventionResultStore.load({
                addData: ['tags'],
                query: {
                    uuidv4,
                    hostname: conventionResultStore.currentHostname,
                },
                skipUpdate: true,
            });
            conventionResultStore.updateKeyValue('conventionResult', conventionResults[0]);
            appState.updateMetaTags(conventionResults[0]);
            const { conventionResult } = conventionResultStore;
            if (conventionResult.googleSheetId) {
                conventionResultStore.getGoogleSheet(conventionResult.googleSheetId);
            }
        }
    }

    viewTags = obj => {
        if (obj.tags?.length === 0 && obj.loans?.length === 0 && !obj.ownedByOther && !obj.url && !obj.parents?.length > 0 && !obj.files?.length > 0) {
            return '';
        }
        const { userStore } = this.props.stores;
        const { user = {} } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');
        const tagClass = darkmode ? 'dark' : 'light';

        return (<>
            <div class='w-100 overflow-hidden'>
                <div class='box-line-tags d-flex flex-nowrap'>
                    {obj.files?.length > 0 && <>
                        <span class={`badge text-bg-light me-1 mt-1`}>
                            <i class='fa-duotone fa-file' /> <span class='font-weight-lighter'> x {obj.files.length}</span>
                        </span>
                    </>}
                    {obj.tags?.length > 0 && obj.tags.map(tag => {
                        return (<>
                            <span
                                class={`badge text-bg-${tagClass} me-1 mt-1`}
                                onClick={this.toggleTagFilter}
                                data-tag={tag.name}
                            >#{tag.name}</span>
                        </>);
                    })}
                </div>
            </div>
        </>);
    }

    editConventionResult = () => {
		const { id, drawerLevel } = this.props;
		const { appState } = this.props.stores;
		const { drawerHeightMedium } = appState;
		appState.openDrawer('editConventionResultImage', {
			height: drawerHeightMedium,
			id,
		}, drawerLevel + 1);
	}

    viewInstallation = e => {
        const { id } = e.currentTarget.dataset;
        const { appState } = this.props.stores;
        appState.toggleDrawer();
        route(`/installation/${id}`);
    }

    closeAllDrawers = () => {
        const { appState } = this.props.stores;
        appState.toggleDrawer();
    }

    componentDidMount() {
        this.loadAll();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.page !== this.props.page || nextProps.artid !== this.props.artid) {
            this.loadAll(nextProps);
        }
    }

    componentWillUnmount() {
        const { appState } = this.props.stores;
        appState.restoreDefaultMetaTags();
    }

    render() {
        const {
            all,
            id,
        } = this.props;
        const { appState, userStore, conventionResultStore } = this.props.stores;
        const { mainView, subView, isDevelopment, path } = appState;
        const { user = {}, isAdmin, isTester, isVeterinary, language } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { conventionResult } = conventionResultStore;

        const linkTextClass = `${darkmode ? 'text-white' : 'text-dark'}`;
		const linkTextStyle = `line-height: 24px; font-size: 21px; font-weight: 400;`;

        if (!id) {
            return (<>
                <div class='w-100 d-flex justify-content-center position-relative'>
                    <div class='w-100 h-100' style='max-width: 960px; padding-top: 0px; padding-bottom: 100px;'>
                        <div class={`d-flex flex-column mx-3 mt-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3`}>
                            <Text id='conventionResult.notFound'>Convention result not found!</Text>
                        </div>
                    </div>
                </div>
            </>);
        }
        if (!conventionResult || !conventionResult?.images?.length) {
            return (<>
                <div class='w-100 d-flex justify-content-center position-relative'>
                    <div class='w-100 h-100' style='max-width: 960px; padding-top: 0px; padding-bottom: 100px;'>
                        <div class={`d-flex flex-column mx-3 mt-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3`}>
                            <Text id='conventionResult.noImagesFound'>No images found!</Text>
                        </div>
                    </div>
                </div>
            </>);
        }

        return (<>
            <div class='w-100 d-flex justify-content-center position-relative'>
                <div class='w-100 h-100' style='max-width: 960px; padding-top: 0px; padding-bottom: 100px;'>
                   {isAdmin && <div class={`position-absolute`} style={`top: 20px; right: 50px; z-index: 100000;`}>
                        <button onClick={this.editConventionResult} class={`btn btn-sm btn-outline-secondary rounded-pill me-2`}>
                            <i class={`fa-regular fa-pen me-2`} />
                            <Text id='conventionResult.edit'>Edit conventionResult</Text>
                        </button>
                    </div>}
                    <div class='w-100 d-flex flex-column'>
                        <div class='px-0 box-header-info d-flex flex-column'>
                            <div class='d-flex flex-column'>
                                {/* {JSON.stringify(part)} */}
                                {conventionResult.files?.length > 0 && conventionResult.files.map(file => {
                                    const poster = file.s3LinkStreamPreview1;
                                    // console.log({ file });
                                    if (file.s3LinkStream) {
                                        return (<>
                                            <div class='video-container rounded-lg'>
                                                <VideoStreamingPlayer
                                                    key={file.s3LinkStream}
                                                    videoStreamUrl={file.s3LinkStream}
                                                    stores={this.props.stores}
                                                    poster={poster}
                                                />
                                            </div>
                                        </>);
                                    }
                                    if (file.s3Link.match(/\.(m4v|m4a|mp4)$/i)) {
                                        return (<>
                                            <div className='video-container rounded-lg'>
                                                <video controls className='video-player'>
                                                    <source src={file.s3Link} type='video/mp4' />
                                                    Your browser does not support the video tag.
                                                </video>
                                            </div>
                                        </>);
                                    }
                                    if (file.s3Link.match(/\.(mov)$/i)) {
                                        return (<>
                                            <div className='video-container rounded-lg'>
                                                <video controls className='video-player'>
                                                    <source src={file.s3Link} type='video/quicktime' />
                                                    Your browser does not support the video tag.
                                                </video>
                                            </div>
                                            <div class='video-info d-flex flex-row justify-content-center'>
                                                <span class='text-muted'>size:</span> {localUtil.formatFileSize(file.size)}
                                                <span class='text-muted ms-3 me-1'>encoding:</span> {file.encoding}
                                                <span class='text-muted ms-3 me-1'>mimetype:</span> {file.mimetype}
                                                <span class='text-muted ms-3 me-1'>ext:</span> {file.ext}
                                                <span class='text-muted ms-3 me-1'>s3Link:</span> <a href={file.s3Link} target='_blank' rel='noopener noreferrer'>download</a>
                                            </div>
                                        </>);
                                    }
                                })}
                                <ImageScroller
                                    images={conventionResult.images}
                                    stores={this.props.stores}
                                    showImg={img => displayImage(img, this.props, '1920x')}
                                    maxHeight={'80vh'}
                                    // imageContainerStyles={'aspect-ratio: 4 / 3'}
                                    imageStyles={'aspect-ratio: 4 / 3'}
                                    rounded={false}
                                    // maxWidth={maxWidth}
                                />
                            </div>

                            <ConventionResultAiAnalysisPanel stores={this.props.stores} id={id} />

                            {conventionResult.files && conventionResult.files.length > 0 && <>
                                <div class={`d-flex flex-column mx-3 mt-4 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3`}>
                                    <div class='d-flex flex-column'>
                                        {conventionResult.files.map(file => {
                                            return (<>
                                                <a href={file.s3Link} class='badge text-bg-light border me-2' target='_blank' rel='noopener noreferrer'>{file.name} <span class='font-weight-lighter'>({localUtil.formatFileSize(file.size)})</span></a>
                                            </>);
                                        })}
                                    </div>
                                </div>
                            </>}

                            {conventionResult.tags && conventionResult.tags.length > 0 && <div class={`d-flex flex-column mx-3 mt-4 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3`}>
                                {this.viewTags(conventionResult)}
                            </div>}

                        </div>
                    </div>

                    {/* <SimpleBlog stores={this.props.stores} {...this.props} /> */}
                </div>
            </div>
        </>);
    }
}

export default ConventionResultView;
